import { render, staticRenderFns } from "./top-vendor.vue?vue&type=template&id=09a652df&scoped=true&"
import script from "./top-vendor.vue?vue&type=script&lang=js&"
export * from "./top-vendor.vue?vue&type=script&lang=js&"
import style0 from "./top-vendor.vue?vue&type=style&index=0&id=09a652df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a652df",
  null
  
)

export default component.exports